import { Component } from '@angular/core';

@Component({
  selector: 'app-favorite',
  imports: [],
  template: `
    <svg
      width="16"
      height="16"
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_1663_3939)">
        <path
          d="M9.92093 2.51865L11.0943 4.88465C11.2543 5.21399 11.6809 5.52999 12.0409 5.58999L14.1669 5.94665C15.5269 6.17532 15.8469 7.16999 14.8669 8.15132L13.2136 9.81799C12.9336 10.1 12.7803 10.6447 12.8669 11.0347L13.3403 13.098C13.7136 14.7313 12.8536 15.3627 11.4203 14.5093L9.42693 13.3193C9.06693 13.1047 8.47359 13.1047 8.10693 13.3193L6.11493 14.5093C4.68826 15.3627 3.82159 14.724 4.19493 13.098L4.66826 11.0347C4.75493 10.6447 4.60159 10.1 4.32159 9.81799L2.66826 8.15132C1.69559 7.16932 2.00893 6.17532 3.36826 5.94665L5.49493 5.58999C5.84826 5.52999 6.27493 5.21399 6.43493 4.88465L7.60826 2.51865C8.24826 1.23532 9.28826 1.23532 9.92159 2.51865"
          stroke="#424242"
          stroke-width="1.2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_1663_3939">
          <rect
            width="16"
            height="16"
            fill="white"
            transform="translate(0.769043 0.222656)"
          />
        </clipPath>
      </defs>
    </svg>
  `
})
export class FavoriteComponent { }
